import './App.css';
import Header from "./components/Header";
import Main from "./components/Main";
import { useState, useEffect } from 'react';


function App() {

    const [cat_filters] = useState([
        {
            name: 'All',
            id: 1
        },
        {
            name: 'Work',
            id: 2
        },
        {
            name: 'Home',
            id: 3
        },
        {
            name: 'Personal',
            id: 4
        }
    ])

    const [filters] = useState([
        {
            id: 1,
            name: 'To do'
        },
        {
            id: 2,
            name: 'Completed'
        },
        {
            id: 3,
            name: 'All'
        }
    ])

    const [notes, setNotes] = useState([]);

    const [activeNote, setActiveNote] = useState(false);
    const [filteredNotes, setFilteredNotes] = useState([]);

    // Filters: Todo, Completed, All
    const [activeFilter, setActiveFilter] = useState(filters[0]);

    // Category filters: Work, Home, Personal
    const [activeCatFilter, setActiveCatFilter] = useState(cat_filters[0]);

    // Search notes
    const [searchNote, onSearchNote] = useState('');

    // Update when searching a note.
    const updateSearchNotes = (text) => {
        onSearchNote(text);
    }

    useEffect(() => {
        const existingNotes = JSON.parse( localStorage.getItem( 'my-notes-app' ) );
        if ( existingNotes ) {
            setNotes( existingNotes );
        }
    }, []);

    useEffect(() => {
        localStorage.setItem( 'my-notes-app', JSON.stringify(notes) );
    }, [notes]);


    return (
        <div className="app">
            <Header
                cat_filters={cat_filters}
                activeCatFilter={activeCatFilter}
                setActiveCatFilter={setActiveCatFilter}
                filters={filters}
                activeFilter={activeFilter}
                setActiveFilter={setActiveFilter}
                searchNote={searchNote}
                updateSearchNotes={updateSearchNotes}
            />
            <Main
                cat_filters={cat_filters.slice(1)}
                activeCatFilter={activeCatFilter}
                activeFilter={activeFilter}
                notes={notes}
                setNotes={setNotes}
                activeNote={activeNote}
                setActiveNote={setActiveNote}
                filteredNotes={filteredNotes}
                setFilteredNotes={setFilteredNotes}
                searchNote={searchNote}
                setActiveCatFilter={setActiveCatFilter}
                setActiveFilter={setActiveFilter}
                original_cat_filters={cat_filters}
                filters={filters}
            />
        </div>
    );
}

export default App;
